import { Component, Input, OnDestroy, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { Constants } from 'src/app/shared/utils/constants';
import { Permission } from 'src/app/models/permission.model';
import { Customer } from 'src/app/models/customer.model';
import { Subscription } from 'rxjs';
import { CmsService } from '../cms.service';
import { BonusCodeComponent } from '../bonus-code/bonus-code.component';
import { AppService } from 'src/app/app.service';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { AccountService } from '../../../shared/services/account.service';
import { ToastrService } from 'ngx-toastr';
import { ExcelExportService } from '../excel.export.service';
import { DatePipe, DecimalPipe } from '@angular/common';
import { DialogService } from 'primeng/dynamicdialog';
import { CustomerService } from './customer.service';

@Component({
  selector: 'fx-customers',
  templateUrl: './customers.component.html',
  styleUrls: ['./customers.component.sass'],
  providers: [AccountService,DialogService, CustomerService]
})
export class CustomersComponent implements OnInit, OnDestroy {
  @Input() permission: Permission;
  @ViewChild('bonusCode') bonusCode: BonusCodeComponent;
  @ViewChild('confirmInvalidate') confirmInvalidateRef: TemplateRef<unknown>;

  customers: Customer[] = [];
  loading = false;
  condition: any = {
    bonusNAffiliatePayout: false,
    keyword: '',
    coinType: 'btc',
    pnlCoinType: 'btc',
    kyc: '',
    order: 'desc',
    orderBy: 'id',
    kycCode: '',
    from:'',
    to:'',
    activation: '1'
  };
  pageInfo = {
    pageSize: 10,
    pageIndex: 1,
    pageManual: 1,
    totalRecord: 0
  };
  sort = {
    id: 'desc',
    active: 'desc',
    email: 'desc',
    first_name: 'desc'
  };
  subscriptions: any = {
    getAll: new Subscription(),
    export: new Subscription(),
  };
  currency = 'jpy';
  countries = {};
  listKYCStatus = Object.entries(Constants.KYC_STATUS);
  currentAccount: Customer = null;
  showError = false
  activationStatus = '1';
  userType = {
    0: 'IB',
    '1': 'IB', '2': 'IB Trader', '3': 'Organic Trader'
  };
  categories = [
    // { label: 'All', value: 'q' },
    { label: 'MT5 ID', value: 'mt5_account' },
    { label: 'Username', value: 'en_username' },
    { label: 'Username (JP)', value: 'jp_username' },
    { label: 'Email', value: 'email' },
  ]
  selectedCategory = this.categories[0];
  searchConditionParams: any = {};
  sortStatus = false;
  orderType = {
    id: 'mt5_account',
    email: 'email',
    active: 'active',
    first_name: 'first_name'
  }
  constructor(
    private service: CmsService,
    public appService: AppService,
    private datePipe: DatePipe,
    private decimalPipe: DecimalPipe,
    private excelExportService: ExcelExportService,
    private readonly dialog: MatDialog,
    private readonly accountService: AccountService,
    private readonly toast: ToastrService,
  ) {
      Constants.COUNTRIES.map((c) => {
        this.countries[c.code]= { label: c.name, value: c.code, dialCode: c.dialCode }
      });
  }

  ngOnInit(): void {
    this.getCustomers();
  }

  onActivationChange(t) {
    this.pageInfo.pageIndex = 1;
    this.pageInfo.pageManual = 1;
    this.condition.activation = t;
    this.getCustomers();
  }

  openConfirmInvalidateDialog(account: Customer): void {
    this.currentAccount = account;
    this.dialog.open(this.confirmInvalidateRef, {
      backdropClass: 'custom-backdrop-color'
    }).afterClosed().subscribe(() => {
      this.currentAccount = null;
    });
  }

  onInvalidate(): void {
    this.accountService.disableAccountStatus(this.currentAccount.id.toString()).subscribe({
      next: r => {
        if(r.status === 1000) {
          this.toast.success(`Disable successfully!`, '', {positionClass: 'toast-top-center'});
          this.getCustomers();
          this.dialog.closeAll();
        } else {
          this.dialog.closeAll();
          this.toast.error(`Something went wrong!`,'', {positionClass: 'toast-top-center'})
        }
      }
    });
  }

  onPageChange($event: any): void {
    this.pageInfo.pageIndex = $event;
    this.pageInfo.pageManual = $event;
    this.getCustomers();
  }

  onKeyup(evt: KeyboardEvent): void {
    if (evt.keyCode === 13) {
      this.pageInfo.pageIndex = 1;
      this.condition.keyword = '';
      this.getCustomers();
    }
  }
  onKeyupPage(evt: KeyboardEvent): void {
    if (evt.keyCode === 13) {
      this.pageInfo.pageIndex = this.pageInfo.pageManual;
      this.getCustomers();
    }
  }

  refreshPage() {
    this.selectedCategory = this.categories[0];
    this.condition.keyword = '';
    this.pageInfo = {
      ...this.pageInfo,
      pageIndex: 1,

    }
    this.sort = {
      id: 'desc',
      active: 'desc',
      email: 'desc',
      first_name: 'desc',
    };
    this.activationStatus = '1';
    this.condition.kycCode = '';
    this.condition.order = 'desc';
    this.condition.orderBy = 'id';
    this.condition.activation = '1'
    this.searchConditionParams = {};
    this.getCustomers();
  }

  getCustomers(): void {
    this.subscriptions.getAll = this.service
      .getCustomers({
        category: this.selectedCategory.value,
        q: encodeURIComponent((this.condition.keyword).trim()) || '',
        page: this.pageInfo.pageIndex,
        page_size: this.pageInfo.pageSize,
        user_active: this.condition.activation,
        kyc: this.condition.kycCode,
        order_type: this.condition.order,
        order_by: this.orderType[this.condition.orderBy] ?? 'mt5_account',
        //...this.searchConditionParams
      })
      .subscribe((data) => {
        if (data.status === Constants.RESPONSE_STATUS.SUCCESS) {
          this.customers = data.data;
          this.pageInfo.totalRecord = data.paging.total;
        }
        this.loading = false;
      });
  }

  sortBy(column: string): void {
    this.sort[column] = this.sort[column] === 'desc' ? 'asc' : 'desc';
    this.condition.orderBy = column;
    this.condition.order = this.sort[column];
    this.getCustomers();
  }

  sorting(key: string): void {
    this.sortStatus = !this.sortStatus;
    this.customers.sort((a, b) => {
      if(this.sortStatus) {
        return (String(a[key])).localeCompare(String(b[key]));
      } else {
        return (String(b[key])).localeCompare(String(a[key]));
      }
    })
  }

  confirm(customer): any {
    if (!customer.isAffiliate && this.permission.allowUpdating) {
      return confirm('Are you sure that you want to turn on affiliate?');
    }
    return false;
  }

  getListByKycStatus(): void {

    this.getCustomers();
  }

  exportAllByClient() {
    this.service.exportAllByClient();
  }

  onExport() {
    this.subscriptions.getExport = this.service
    .exportCustomers({
      is_export: 1,
      // user_active: this.condition.activation,
    }).subscribe();
    // const fileName = 'customer_list';
    // let data: Record<string, any>[] = this.customers?.map(customer => ({
    //   "MT5 ID": customer.mt5Account,
    //   "IB ID": customer.id,
    //   "MAMPAMM": customer.isMam === 0 ? "NO" : "YES",
    //   "MT5 account opening date": customer.mt5CreateTime ? this.datePipe.transform(customer.mt5CreateTime, "yyyy-MM-dd") : "",
    //   "Activation": customer.getActivation(),
    //   "Username": customer.getUsername(),
    //   "Username (JP)": customer.getUsernameJP(),
    //   "Email": customer.email,
    //   "Address": "",
    //   "KYC": customer.getTextKYC(),
    //   "Country": this.getCountryNameByCode(customer.country),
    //   "Total Vol": customer.totalVolume.toFixed(2),
    //   "Total Order": customer.totalOrder,
    //   "Currency": customer.currency?.toUpperCase() ?? "",
    //   "Total Balance": this.decimalPipe.transform(customer.totalBalance, this.fixedNumber[customer.currency]),
    //   "Total PnL": this.decimalPipe.transform(customer.totalPNL, this.fixedNumber[customer.currency]),
    //   "Realized PnL": this.decimalPipe.transform(customer.realizedPnl, this.fixedNumber[customer.currency]),
    //   "Total Deposit": this.decimalPipe.transform(customer.deposit, this.fixedNumber[customer.currency]),
    //   "Total Withdraw": this.decimalPipe.transform(customer.withdraw, this.fixedNumber[customer.currency]),
    //   "Net Asset": this.decimalPipe.transform(customer.netAsset, this.fixedNumber[customer.currency]),
    //   "PROFIT/NET BALANCE RATIO": customer.getPercentBalanceRatio(),
    //   "BONUS": this.decimalPipe.transform(customer.bonus, this.fixedNumber[customer.currency]),
    //   "Status": customer.active === 1 ? 'ACTIVE' : 'INACTIVE',
    // })) ?? [];
    // this.excelExportService.exportExcel(data, fileName);
  }
  ngOnDestroy(): void {
    for (const key in this.subscriptions) {
      if (this.subscriptions.hasOwnProperty(key) && this.subscriptions[key]) {
        this.subscriptions[key].unsubscribe();
      }
    }
  }

  setSearchConditionParams(params: any = {}) {
    this.searchConditionParams = (this.selectedCategory.value.length > 0 && params.key && params.value) ? {
      [params.key]: encodeURIComponent((params.value)).trim()
    } : {};
  }

  onSelectTypeChange() {
    this.condition.keyword = ''
  }

  onSearch() {
    this.pageInfo.pageIndex = 1;
    this.pageInfo.pageManual = 1;
    this.setSearchConditionParams({key: this.selectedCategory.value, value: this.condition.keyword});
    this.getCustomers();
  }

}
